//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import Vue from "vue";

export default {
  components: {},

  computed: {
    ...mapGetters(["getFbToken", "getHostname"]),
  },

  data() {
    return {
      code: "",
    };
  },

  async created() {
    if ("" + this.$route.query.code !== "undefined") {
      this.code = this.$route.query.code;
      this.$router.push("/settings");

      this.postInstagramToken(this.code);
    }
  },

  methods: {
    ...mapActions(["postInstagramToken"]),

    logout() {
      this.$store.dispatch("logout");
    },
  },
};
